export default __webpack_public_path__ + "static/media/logo.84aeb307.svg";